import { Info } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const InfoIcon = createLucideIcon(Info);
